const { NODE_ENV } = process.env;

const isProd = NODE_ENV === "production";

const domain = isProd ? "https://www.diario24horas.com.br" : "http://localhost:8080";
const API_URL = isProd ? "https://www.diario24horas.com.br/api" : "http://localhost:8080/api"
const cdn = "https://static.diario24horas.com.br";

export { domain, cdn, API_URL };